import { z } from 'zod';

// Common password validation
const passwordSchema = z
	.string()
	.min(8, 'Password must be at least 8 characters long')
	.regex(/[a-z]/, 'Password must contain at least one lowercase letter')
	.regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
	.regex(/\d/, 'Password must contain at least one number')
	.regex(
		/[^a-zA-Z0-9]/,
		'Password must contain at least one special character'
	);

// Email validation
const emailSchema = z
	.string()
	.min(1, 'Email is required')
	.email('Please enter a valid email address');

// Login schema
export const loginSchema = z.object({
	email: emailSchema,
	password: z.string().min(1, 'Password is required'),
});

// Register schema
export const registerSchema = z
	.object({
		email: emailSchema,
		password: passwordSchema,
		confirmPassword: z.string(),
		name: z.string().optional(),
	})
	.refine((data) => data.password === data.confirmPassword, {
		message: "Passwords don't match",
		path: ['confirmPassword'],
	});

// Forgot password schema
export const forgotPasswordSchema = z.object({
	email: emailSchema,
});

// Update password schema
export const updatePasswordSchema = z
	.object({
		password: passwordSchema,
		confirmPassword: z.string(),
	})
	.refine((data) => data.password === data.confirmPassword, {
		message: "Passwords don't match",
		path: ['confirmPassword'],
	});

// Type exports
export type LoginFormData = z.infer<typeof loginSchema>;
export type RegisterFormData = z.infer<typeof registerSchema>;
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;
export type UpdatePasswordFormData = z.infer<typeof updatePasswordSchema>;
